import gcRoles from '@/app/geo/gradecontrol/roles.js'
import ReportEnum from '@/app/geo/gradecontrol/reports/reportEnum'

export default [
  {
    path: '/geo/gradecontrol',
    name: 'geo-gradecontrol',
    component: () => import('@/app/geo/gradecontrol/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', active: true, i18n: 'GradeControl.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control'
    }
  },
  {
    path: '/geo/gradecontrol/timesheet',
    name: 'geo-gradecontrol-timesheet',
    component: () => import('@/app/geo/gradecontrol/timesheet/timesheet.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Timesheet', active: true,  i18n: 'GradeControl.Timesheet.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Timesheet.Title'
    }
  },
  {
    path: '/geo/gradecontrol/forecast',
    name: 'geo-gradecontrol-forecast',
    component: () => import('@/app/geo/gradecontrol/forecast/forecast.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Forecast', active: true, i18n: 'GradeControl.Forecast.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Forecast',
      i18n: 'GradeControl.Forecast.Title'
    }
  },
  {
    path: '/geo/gradecontrol/reports',
    name: 'geo-gradecontrol-reports',
    component: () => import('@/app/geo/gradecontrol/reports/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', active: true, i18n: 'GradeControl.Reports.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.Title'
    }
  },
  {
    path: '/geo/gradecontrol/reports/locationsummary',
    name: 'geo-gradecontrol-report-locationsummary',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.LocationSummary
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Location Summary', active: true, i18n: 'GradeControl.Reports.LocationSummary' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.LocationSummary'
    }
  },
  {
    path: '/geo/gradecontrol/reports/productionsummary',
    name: 'geo-gradecontrol-report-productionsummary',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.ProgressChart
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Production Summary', active: true, i18n: 'GradeControl.Reports.ProductionSummary' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.ProductionSummary'
    }
  },
  {
    path: '/geo/gradecontrol/monthlySummary',
    name: 'geo-gradecontrol-monthlySummary',
    component: () => import('@/app/geo/gradecontrol/monthlySummary/monthlySummary.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Forecast Summary', active: true, i18n: 'GradeControl.MonthlySummary.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Monthly Summary',
      i18n: 'GradeControl.MonthlySummary.Title'
    }
  },
  {
    path: '/geo/gradecontrol/productionsummary',
    name: 'geo-gradecontrol-productionsummary',
    component: () => import('@/app/geo/gradecontrol/productionsummary/productionSummary.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Production Summary', active: true, i18n: 'GradeControl.ProductionSummary.LongTitle' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Production Summary',
      i18n: 'GradeControl.ProductionSummary.Title'
    }
  },
  {
    path: '/geo/gradecontrol/reports/postingsummary',
    name: 'geo-gradecontrol-report-postingsummary',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.PostingSummary
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Posting Summary', active: true, i18n: 'GradeControl.Reports.PostingSummary' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.PostingSummary'
    }
  },
  {
    path: '/geo/gradecontrol/reports/periodicsummary',
    name: 'geo-gradecontrol-report-periodicsummary',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.Summary
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Summary', active: true, i18n: 'GradeControl.Reports.Summary' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.Summary'
    }
  },
  {
    path: '/geo/gradecontrol/reports/periodicsummarymaterialtypes',
    name: 'geo-gradecontrol-report-periodicsummarymaterialtypes',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.Summary,
      materialTypeNames: ['Acid', 'Sterile', 'Stand-by', 'Heap Leach'],
      showMaterialType: true,
      showNavPane : false
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Dashboard', active: true, i18n: 'GradeControl.Reports.SummaryOtherMaterial' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.SummaryOtherMaterial'
    }
  },
  {
    path: '/geo/gradecontrol/reports/dailymonitoring',
    name: 'geo-gradecontrol-report-dailymonitoring',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.DailyMonitoring,
      forceProject: true
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Daily Monitoring', active: true, i18n: 'GradeControl.Reports.DailyMonitoring' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.DailyMonitoring'
    }
  },
  {
    path: '/geo/gradecontrol/reports/dailyLocationStats',
    name: 'geo-gradecontrol-report-daily-location-stats',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlDailyLocationStats',
      isPaginated : true
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'DailyLocationStats', active: true, i18n: 'GradeControl.Reports.DailyLocationStats' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Stockpile report',
      i18n: 'GradeControl.Reports.DailyLocationStats'
    }
  },
  {
    path: '/geo/gradecontrol/reports/locationSummaryStats',
    name: 'geo-gradecontrol-report-location-summary-stats',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlLocationSummaryStats',
      isPaginated : true
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'LocationSummaryStats', active: true, i18n: 'GradeControl.Reports.LocationSummaryStats' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Location Summary Stats',
      i18n: 'GradeControl.Reports.LocationSummaryStats'
    }
  },

  {
    path: '/geo/gradecontrol/reports/samplestats',
    name: 'geo-gradecontrol-report-samplestats',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.SampleStats
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Sample Stats', active: true, i18n: 'GradeControl.Reports.SampleStats' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.Dashboard'
    }
  },
  {
    path: '/geo/gradecontrol/reports/labstats',
    name: 'geo-gradecontrol-report-labstats',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.LabStats
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Sample Stats', active: true, i18n: 'GradeControl.Reports.LabStats' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.Dashboard'
    }
  },
  {
    path: '/geo/gradecontrol/reports/sampleanomalies',
    name: 'geo-gradecontrol-report-sampleanomalies',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.SampleAnomalies
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Sample Anomalies', active: true, i18n: 'GradeControl.Reports.SampleAnomalies' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.Dashboard'
    }
  },
  {
    path: '/geo/gradecontrol/reports/samplesummary',
    name: 'geo-gradecontrol-report-samplesummary',
    component: () => import('@/app/geo/gradecontrol/reports/summary.vue'),
    props: {
      pageId: ReportEnum.SampleSummary
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Sample Summary', active: true, i18n: 'GradeControl.Reports.SampleSummary' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Reports.Dashboard'
    }
  },
  {
    path: '/geo/gradecontrol/reports/sample',
    name: 'geo-gradecontrol-report-sample',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlSamples'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Sample Tracking', active: true, i18n: 'GradeControl.Reports.SampleTracking' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Sample Tracking',
      i18n: 'GradeControl.Reports.SampleTracking'
    }
  },
  {
    path: '/geo/gradecontrol/reports/deswikexport',
    name: 'geo-gradecontrol-report-deswik-export',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlDeswikExport',
      isPaginated : true
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'DeswikReport', active: true, i18n: 'GradeControl.Reports.DeswikExport' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Deswik Export',
      i18n: 'GradeControl.Reports.DeswikExport'
    }
  },
  {
    path: '/geo/gradecontrol/reports/odysseydeswikexport',
    name: 'geo-gradecontrol-report-odyssey-deswik-export',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlOdysseyDeswikExport',
      isPaginated : true
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'DeswikReport', active: true, i18n: 'GradeControl.Reports.DeswikExport' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Deswik Export',
      i18n: 'GradeControl.Reports.DeswikExport'
    }
  },
  {
    path: '/geo/gradecontrol/reports/detourdeswikexport',
    name: 'geo-gradecontrol-report-detour-deswik-export',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlDetourDeswikExport',
      isPaginated : true
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'DeswikReport', active: true, i18n: 'GradeControl.Reports.DeswikExport' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Deswik Export',
      i18n: 'GradeControl.Reports.DeswikExport'
    }
  },
  {
    path: '/geo/gradecontrol/posting',
    name: 'geo-gradecontrol-posting',
    component: () => import('@/app/geo/gradecontrol/posting/posting.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Posting', active: true, i18n: 'GradeControl.Posting.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Posting',
      i18n: 'GradeControl.Posting.Title'
    }
  },
  {
    path: '/geo/gradecontrol/reports/timesheet',
    name: 'geo-gradecontrol-report-timesheet',
    component: () => import('@/app/geo/gradecontrol/reports/timesheet.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Timesheet', active: true, i18n: 'GradeControl.Reports.Timesheet' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Timesheet report',
      i18n: 'GradeControl.Reports.Timesheet'
    }
  },
  {
    path: '/geo/gradecontrol/reports/muck',
    name: 'geo-gradecontrol-report-muck',
    component: () => import('@/app/geo/gradecontrol/reports/muck.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Muck', active: true, i18n: 'GradeControl.Reports.Muck' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Muck report',
      i18n: 'GradeControl.Reports.Muck'
    }
  },
  {
    path: '/geo/gradecontrol/reports/timesheet2',
    name: 'geo-gradecontrol-report-timesheet2',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlTimesheet'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Timesheet', active: true, i18n: 'GradeControl.Reports.Timesheet' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Timesheet report',
      i18n: 'GradeControl.Reports.Timesheet'
    }
  },
  {
    path: '/geo/gradecontrol/reports/muck2',
    name: 'geo-gradecontrol-report-muck2',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlMuck'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Muck', active: true, i18n: 'GradeControl.Reports.Muck' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Muck report',
      i18n: 'GradeControl.Reports.Muck'
    }
  },
  {
    path: '/geo/gradecontrol/reports/stockpile',
    name: 'geo-gradecontrol-report-stockpile',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'powerBiGroupId',
      reportId: 'gradeControlStockPile'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Report', url: '/geo/gradecontrol/reports', i18n: 'GradeControl.Reports.Title' },
        { title: 'Stockpile', active: true, i18n: 'GradeControl.Reports.Stockpile' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.readers,
      pageTitle: 'Stockpile report',
      i18n: 'GradeControl.Reports.Stockpile'
    }
  },
  {
    path: '/geo/gradecontrol/samples',
    name: 'geo-gradecontrol-samples',
    component: () => import('@/app/geo/gradecontrol/samples/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Sample', active: true,  i18n: 'GradeControl.Sample.LIMSTitle' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.samples,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Sample.LIMSTitle'
    }
  },
  {
    path: '/geo/gradecontrol/admin',
    name: 'geo-gradecontrol-admin',
    component: () => import('@/app/geo/gradecontrol/admin/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Admin', active: true,  i18n: 'GradeControl.Admin.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Admin.Title'
    }
  },
  {
    path: '/geo/gradecontrol/admin/locations',
    name: 'geo-gradecontrol-admin-locations',
    component: () => import('@/app/geo/gradecontrol/admin/locations/Locations.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Admin', url: '/geo/gradecontrol/admin', i18n: 'GradeControl.Admin.Title' },
        { title: 'Locations', active: true,  i18n: 'GradeControl.Location.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Location.Title'
    }
  },
  {
    path: '/geo/gradecontrol/admin/employees',
    name: 'geo-gradecontrol-admin-employees',
    component: () => import('@/app/geo/gradecontrol/admin/employees/Employees.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Admin', url: '/geo/gradecontrol/admin', i18n: 'GradeControl.Admin.Title' },
        { title: 'Employees', active: true,  i18n: 'GradeControl.Employee.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.employeesCollaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Employee.Title'
    }
  },
  {
    path: '/geo/gradecontrol/admin/mucktypes',
    name: 'geo-gradecontrol-admin-mucktypes',
    component: () => import('@/app/geo/gradecontrol/admin/mucktypes/MuckTypes.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Admin', url: '/geo/gradecontrol/admin', i18n: 'GradeControl.Admin.Title' },
        { title: 'MuckTypes', active: true,  i18n: 'GradeControl.MuckType.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.MuckType.Title'
    }
  },
  {
    path: '/geo/gradecontrol/admin/equipments',
    name: 'geo-gradecontrol-admin-equipments',
    component: () => import('@/app/geo/gradecontrol/admin/equipments/Equipments.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Admin', url: '/geo/gradecontrol/admin', i18n: 'GradeControl.Admin.Title' },
        { title: 'Equipments', active: true,  i18n: 'GradeControl.Equipment.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Equipment.Title'
    }
  },
  {
    path: '/geo/gradecontrol/admin/materialsubtypes',
    name: 'geo-gradecontrol-admin-materialsubtypes',
    component: () => import('@/app/geo/gradecontrol/admin/materialsubtypes/MaterialSubTypes.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Admin', url: '/geo/gradecontrol/admin', i18n: 'GradeControl.Admin.Title' },
        { title: 'MaterialSubTypes', active: true,  i18n: 'GradeControl.MaterialSubType.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.MaterialSubType.Title'
    }
  },
  {
    path: '/geo/gradecontrol/admin/destinations',
    name: 'geo-gradecontrol-admin-destinations',
    component: () => import('@/app/geo/gradecontrol/admin/destinations/Destinations.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'Admin', url: '/geo/gradecontrol/admin', i18n: 'GradeControl.Admin.Title' },
        { title: 'Destinations', active: true,  i18n: 'GradeControl.Destinations.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'Grade Control',
      i18n: 'GradeControl.Destinations.Title'
    }
  },
  {
    path: 'geo/gradecontrol/nsr',
    name: 'geo-gradecontrol-nsr',
    component: () => import('@/app/geo/gradecontrol/nsr/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Grade Control', url: '/geo/gradecontrol', i18n: 'GradeControl.Title' },
        { title: 'NSR', active: true, i18n: 'GradeControl.NSRForecast.Title' }
      ],
      requireAuth: true,
      requireRoles: gcRoles.collaborators,
      pageTitle: 'NSR',
      i18n: 'GradeControl.NSRForecast.Title'
    }
  }
]